module.exports = __webpack_public_path__ + "static/media/protect.7bc75064.svg";